import React, {Component} from 'react'
import I18n from 'app/common/i18n';
import {Field} from 'dk-ui-lib';
import _ from 'lodash';

class LoginInfo extends Component {
  render() {
    let { academy, updateAcademyLoginEmail, updateAcademyLoginName, showStatus } = this.props;

    let user = _.head(academy);
    let userError = academy.errors && _.head(academy.errors);
    let nameError = userError && userError.name ? {error: userError.name} : {};
    let emailError = userError && userError.email ? {error: userError.email} : {};

    return (
      <div className='mt3 mr3'>
        <div className='black bold h4'>{I18n.t('onboard.create_login')}</div>
        <div className='mt2 border flex px1 py2'>
          <div className='col-4 mr4'>
            <Field
              value={user && user.name}
              onChange={updateAcademyLoginName}
              label={I18n.t('onboard.login_name')}
              inputType={'text'}
              errorPosition='bottom'
              shouldHideValidationMsg={false}
              shouldHideValidationIcon={true}
              shouldHideRedBorder={false}
              msgs={showStatus && nameError}/>
          </div>
          <div className='col-7'>
            <div>
              <Field
                value={user && user.email}
                onChange={updateAcademyLoginEmail}
                label={I18n.t('onboard.login_email')}
                inputType={'text'}
                errorPosition='bottom'
                shouldHideValidationMsg={false}
                shouldHideValidationIcon={true}
                shouldHideRedBorder={false}
                msgs={showStatus && emailError}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoginInfo;


// WEBPACK FOOTER //
// ./src/views/academy-onboard/LoginInfo.js